import { render, staticRenderFns } from "./TravelMapOld.vue?vue&type=template&id=63df31bf"
import script from "./TravelMapOld.vue?vue&type=script&lang=js"
export * from "./TravelMapOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports